__turbopack_context__.v({
  "content": "CXN3JG_content",
  "header": "CXN3JG_header",
  "listItem": "CXN3JG_listItem",
  "number": "CXN3JG_number",
  "topWrapper": "CXN3JG_topWrapper",
});
